export const mediaSm = '@media (max-width: 500px)';
export const mediaMd = '@media (max-width: 901px)';
// export const mediaMd = '@media (max-width: 768px)';
// export const mediaLg = '@media (min-width: 901px) and (max-width: 1170px)';
export const mediaLg = '@media (max-width: 1024px)';
export const mediaXl = '@media (min-width: 1171px)';
